import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { GiftIcon, XIcon } from 'lucide-react';
import { useExitIntent } from '../hooks/useExitIntent';
const SPECIAL_OFFER_URL = 'https://funcional-365.impultienda.ar/oferta-especial?store_id=65a709ab-673c-48de-b184-75fdd7bb3c68';
export function ExitIntentModal() {
  const {
    closeOffer,
    isOpen
  } = useExitIntent();
  const dialogRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    closeButtonRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        closeOffer();
        return;
      }
      if (event.key !== 'Tab' || !dialogRef.current) return;
      const focusableElements = Array.from(dialogRef.current.querySelectorAll<HTMLElement>('a[href], button:not([disabled])'));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];
      if (!firstElement || !lastElement) return;
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [closeOffer, isOpen]);
  return <AnimatePresence data-id="element-150" data-mp="w4oa0g7ndynv">
      {isOpen && <motion.div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} role="presentation" data-id="element-151" data-mp="1a2cu3ltw51rv">
          <motion.div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="exit-offer-title" aria-describedby="exit-offer-description" className="relative w-full max-w-md overflow-hidden rounded-[20px] border-2 border-brandOrange bg-bg-card p-6 text-center shadow-[0_0_60px_rgba(255,107,0,0.35)] md:p-8" initial={{
        opacity: 0,
        scale: 0.92,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} data-id="element-152" data-mp="2gif66aesgwn1">
            <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-brandOrange/10" data-id="element-153" data-mp="zgw502l3tkjw" />
            <button ref={closeButtonRef} type="button" onClick={closeOffer} className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full border border-line bg-bg-highlight text-txt-muted transition-colors hover:border-brandOrange hover:text-txt-primary focus:outline-none focus:ring-2 focus:ring-brandOrange" aria-label="Cerrar oferta exclusiva" data-id="element-154" data-mp="14dwc8gtowtcl">
              <XIcon size={18} aria-hidden="true" data-id="element-155" data-mp="470rgt5pslq4" />
            </button>

            <div className="relative mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-brandOrange/40 bg-brandOrange/15 text-brandOrange shadow-[0_0_24px_rgba(255,107,0,0.25)]" data-id="element-156" data-mp="44oekuetd1jx">
              <GiftIcon size={28} aria-hidden="true" data-id="element-157" data-mp="3mcdq2bfxpn0z" />
            </div>
            <p className="relative mb-2 font-sans text-[10px] font-bold uppercase tracking-[1.8px] text-brandOrange" data-id="element-158" data-mp="3mdow6hwur6v9">
              Oferta exclusiva por ahora
            </p>
            <h2 id="exit-offer-title" className="relative mb-4 font-display text-[30px] font-extrabold uppercase leading-[1.05] text-txt-primary md:text-[38px]" data-id="element-159" data-mp="3cnccst0rxjqp">
              ¡Esperá! Tenemos un regalo para vos <span aria-hidden="true" data-id="element-160" data-mp="33npa83wb67w2">🎁</span>
            </h2>
            <p id="exit-offer-description" className="relative mx-auto mb-6 max-w-sm font-sans text-[14px] leading-[1.65] text-txt-body md:text-[16px]" data-id="element-161" data-mp="2yo48xmto1ng6">
              Antes de irte, mirá esta oferta exclusiva con un descuento que solo está disponible ahora.
            </p>

            <div className="relative flex flex-col gap-3" data-id="element-162" data-mp="stlf9rn7zt9b">
              <a href={SPECIAL_OFFER_URL} className="inline-flex w-full items-center justify-center rounded-[14px] bg-brandOrange px-6 py-4 font-sans text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_0_28px_rgba(255,107,0,0.45)] transition-all hover:-translate-y-0.5 hover:bg-brandOrange-hover hover:shadow-[0_0_42px_rgba(255,107,0,0.6)] focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 focus:ring-offset-bg-card" data-id="element-163" data-mp="xs501oq2uz03">
                Ver oferta
              </a>
              <button type="button" onClick={closeOffer} className="inline-flex w-full items-center justify-center rounded-[14px] border border-line bg-bg-highlight px-6 py-3.5 font-sans text-[14px] font-bold text-txt-muted transition-colors hover:border-gray-600 hover:text-txt-primary focus:outline-none focus:ring-2 focus:ring-brandOrange focus:ring-offset-2 focus:ring-offset-bg-card" data-id="element-164" data-mp="2475z43aefxaw">
                No, gracias
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}